/**
 * design_handoff_accept_invitation §3 — the context line under the Create
 * account heading: a 24px workspace mark + "Joining {workspace} as {role}".
 *
 * @param {{name: string, icon?: string}} organization
 * @param {string=} role
 */
import React from "react";
import { getUploadResourceUrl } from "../../../../helpers/url";
import { initialsFromName } from "../../templates/PageTemplate/useAccountShellData";
import { ROLE_LABELS } from "../OrganizationMembersPage/constants";
import styles from "./WorkspaceContextLine.module.scss";

const WorkspaceContextLine = ({ organization, role }) => {
  const icon = organization.icon
    ? getUploadResourceUrl(organization.icon)
    : null;

  const roleLabel = role ? ROLE_LABELS[role] || role : null;

  const mark = icon ? (
    <img src={icon} alt="" />
  ) : (
    initialsFromName(organization.name)
  );

  const roleSuffix = roleLabel ? ` as ${roleLabel}` : "";

  return (
    <p className={styles.root}>
      <span className={styles.mark}>{mark}</span>
      Joining <b>{organization.name}</b>
      {roleSuffix}
    </p>
  );
};

export default WorkspaceContextLine;
